<template>
  <div class="container">
    <div class="handle-wrapper">
      <div class="handle-left">
        <Input
          v-model="searchText"
          search
          placeholder="搜索客户..."
          @on-change="searchCustomer"
          clearable
          icon="ios-search"
          style="width: 230px; margin-right: 20px"
        >
        </Input>
        <Select
          placeholder="筛选状态"
          v-model="selectStatus"
          label-in-value
          clearable
          @on-change="choseStatus"
          style="width: 120px; margin-right: 30px"
        >
          <Option
            v-for="item in statusList"
            :value="item.value"
            :key="item.value"
          >{{ item.label }}</Option>
        </Select>
      </div>
      <div class="handle-right">
        <div class="page-wrap">
          <span>共{{ totalRows }}条</span>
          <Page
            :total="totalRows"
            :page-size="20"
            @on-change="loadCustomerQzReview"
            show-total
            simple
            style="margin-right: 24px"
          />
        </div>
      </div>
    </div>
    <div class="table-wrapper" ref="tableWrapper">
      <Table
        :columns="columns"
        :data="customerQZUpdateFormList"
        :height="tableHeight"
        :loading="tableLoading"
        border
      >
        <template
          slot-scope="{ row }"
          slot="operate"
        >
          <div v-if="row.status === 'applying'">
            <Button class="operate-button" @click="previewQzForm('agree', row)" type="success">同意</Button>
            <Button class="operate-button" @click="previewQzForm('refuse', row)" type="error">拒绝</Button>
            <Button class="operate-button" @click="previewQzForm('cancel', row)" type="warning" ghost>取消</Button>
          </div>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import axios from "@/utils/axios";

const statusToText = {
  applying: "申请中",
  agree: "已同意",
  refuse: "已拒绝",
  cancel: "已取消",
};

export default {
  name: 'customerQzUpdateFormReview',
  data() {
    return {
      tableHeight: 300,
      searchText: null,
      tableLoading: false,
      limit: 20,
      page: 0,
      filterQuery: {},
      selectStatus: null,
      columns: [
        {
          title: "客户",
          key: "customer",
          minWidth: 140,
          maxWidth: 280,
          render: (h, params) => {
            return h("span", params.row.customer.abbr || params.row.customer.name);
          },
        },
        {
          title: "开发",
          key: "devSales",
          minWidth: 140,
          maxWidth: 200,
          render: (h, params) => {
            return h("span", params.row.comissionDivDev?.map((x) => {
              let ratioText = '-';
              if (x.ratio) ratioText = `${(x.ratio*100).toFixed(0)}%`;
              return x.user.name + ' ' + ratioText;
            }).join("、"));
          },
        },
        {
          title: "维护",
          key: "maintainSales",
          minWidth: 140,
          maxWidth: 200,
          render: (h, params) => {
            return h("span", params.row.comissionDivMaintain?.map((x) => {
              let ratioText = '-';
              if (x.ratio) ratioText = `${(x.ratio*100).toFixed(0)}%`;
              return x.user.name + ' ' + ratioText;
            }).join("、"));
          },
        },
        {
          title: "回款",
          key: "paymentSales",
          minWidth: 140,
          maxWidth: 200,
          render: (h, params) => {
            return h("span", params.row.comissionDivPayment?.map((x) => {
              let ratioText = '-';
              if (x.ratio) ratioText = `${(x.ratio*100).toFixed(0)}%`;
              return x.user.name + ' ' + ratioText;
            }).join("、"));
          },
        },
        {
          title: "区域经理",
          key: "regionalCharger",
          width: 100,
          render: (h, params) => h("span", params.row.regionalCharger?.name),
        },
        {
          title: "申请人",
          key: "createdBy",
          width: 100,
          align: "center",
          render: (h, params) => h("span", params.row.createdBy.name),
        },
        {
          title: "审核状态",
          key: "status",
          width: 100,
          align: "center",
          render: (h, params) => h("span", statusToText[params.row.status]),
        },
        {
          title: "操作",
          minWidth: 120,
          align: "center",
          slot: "operate",
        },
      ],
      statusList: [
        {
          value: "applying",
          label: "申请中",
        },
        {
          value: "agree",
          label: "已同意",
        },
        {
          value: "refuse",
          label: "已拒绝",
        },
        {
          value: "cancel",
          label: "已取消",
        },
      ],
    };
  },
  computed: mapState({
    totalRows: (state) => state.customerQZUpdateForm.totalCounts,
    customerQZUpdateFormList: (state) => state.customerQZUpdateForm.customerQZUpdateFormList,
  }),
  methods: {
    ...mapActions({
      getCustomerQzReviewList: "customerQZUpdateForm/getCustomerQZUpdateFormAction",
      reviewCustomerQZUpdateForm: "customerQZUpdateForm/reviewCustomerQZUpdateFormAction"
    }),
    async loadCustomerQzReview(page) {
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        limit: this.limit,
        skip: this.page * this.limit,
      };
      if (this.searchText) {
        this.filterQuery.cus_name = this.searchText;
      } else {
        delete this.filterQuery.cus_name;
      }
      try {
        this.tableLoading = true;
        const data = await this.getCustomerQzReviewList(this.filterQuery);
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败：${error}`);
        this.tableLoading = false;
      }
    },
    searchCustomer() {
      this.page = 0;
      this.loadCustomerQzReview();
    },
    
    async choseStatus(status) {
      if (status) {
        this.filterQuery.status = status.value;
      } else {
        delete this.filterQuery.status;
      }
      await this.loadCustomerQzReview();
    },

    async previewQzForm(review, row) {
      const statusText = statusToText[review]
      try {
        await this.reviewCustomerQZUpdateForm({id: row._id, data: {status: review}})
        this.loadCustomerQzReview()
        this.$Message.success(`${statusText}`);
      } catch (error) {
        this.$Message.error(`审核失败：${error}`);
      }
    }
  },
  async created() {
    this.loadCustomerQzReview();
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>
<style lang="stylus" scoped>
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content space-between

  .handle-left
    display flex
    align-items center

  .handle-right
    display flex
    align-items center

    .page-wrap
      display flex
      align-items center
      min-width 220px

.table-wrapper
  width 100%
  height calc(100% - 48px)

.operate-button
  margin 0 12px
</style>